import { type PingRegistry } from '@canvas/ping-registry';

import { type DatabasePingConfig, databasesPingRegistry } from './ping-registry.ts';

export type DatabasesPingRegistry = PingRegistry<DatabasePingConfig>;

// Named exports for destructuring
export const { key, subscribe, subscribeTo, notify } = databasesPingRegistry;

// Default export for full registry access
export default databasesPingRegistry;

export { useDatabaseSelectionSnapshot } from './use-database-selection-snapshot.ts';

/**
 * Subscribes to selection state changes for a specific entity via
 * ping registry and re-reads from `SelectionsReader`. See {@link useSelectionPing} for full docs.
 */
export { useDatabaseSelectionPing } from './use-selection-ping.ts';
export { useFieldSelectionState } from './use-field-selection-state.ts';
